export default "__VITE_ASSET__BHywklvt__"